module.exports = __webpack_public_path__ + "ncommercial_icon.svg";